<script setup>
/* eslint-disable */
import { useCouponsStore } from '@/stores/coupons';
import PreFixtureDoubleMarket from '@/components/pre_sports/highlights/PreFixtureDoubleMarket.vue'
import LiveFixtureDoubleMarket from '@/components/pre_sports/highlights/LiveFixtureDoubleMarket.vue'
import { useDateTimeSportFiltersStore } from '@/stores/date_time_sport_filters';
import { useInitializeStore } from '@/stores/initialize';
import { onMounted } from 'vue';
import OutrightFixture from './highlights/OutrightFixture.vue';
const couponsStore = useCouponsStore();
const dateTimeSportFiltersStore = useDateTimeSportFiltersStore();
const initializeStore = useInitializeStore();

const props = defineProps({
	date: {
		type: Object
	},
});

</script>

<template>

<div class="live-bet-dashboard competetion-main round-games-main set_game-outer">

	<div class="live-tab-info competition-tab-main">
		<div id="competition" class="tab-content competetion-outer-main">

			<div class="live-info-outer">
				<div class="live-info-inner">
					<div class="live-info-team">

						<div class="live-match competetion-date">
							<div class="live-match-name">
								<h3>{{ date[0].formatted_date }}</h3>
							</div>
						</div>

					</div>

					<!-- <div class="full-time-top top-title-dash" v-if="date.some(date => date.outright == false)">
						<template v-for="(odd, id) in primary_overview_market?.odd_names" :key="id">
							<span v-if="odd != ''">{{ odd }}</span>
						</template>
					</div>

					<div class="match-goal-top top-title-dash" v-if="date.some(date => date.outright == false)">
						<template v-for="(odd, id) in secondary_overview_market?.odd_names" :key="id">
							<span v-if="odd != ''">{{ odd }}</span>
						</template>
						<span class="bet-column-empty"></span>

					</div> -->

				</div>

				<!-- Fixtures -->
				<template v-for="fixture in date" :key="fixture.id">
					<template v-if=" initializeStore.screenWidth > 767">
						<div class="live-info-grid">
							<template v-if="dateTimeSportFiltersStore.selected_overview_market">
								<!-- <OutrightFixture v-if="fixture.outright"
									:primary_overview_market="dateTimeSportFiltersStore.selected_overview_market"
									:secondary_overview_market="dateTimeSportFiltersStore.selected_overview_market"
									:fixture="fixture"
								/>

								<LiveFixtureDoubleMarket v-if="fixture.live && !fixture.outright"
									:primary_overview_market="dateTimeSportFiltersStore.selected_overview_market"
									:secondary_overview_market="dateTimeSportFiltersStore.selected_overview_market"
									:fixture="fixture"
								/> -->

								<PreFixtureDoubleMarket v-if="!fixture.live && !fixture.outright"
									:primary_overview_market="dateTimeSportFiltersStore.selected_overview_market"
									:secondary_overview_market="dateTimeSportFiltersStore.selected_overview_market"
									:fixture="fixture"
								/>
							</template>
						</div>
					</template>
					<template v-else>

							<template v-if="dateTimeSportFiltersStore.selected_overview_market">
								<div v-if="fixture.outright" class="outrightinx">
								<OutrightFixture v-if="fixture.outright"
									:primary_overview_market="dateTimeSportFiltersStore.selected_overview_market"
									:secondary_overview_market="dateTimeSportFiltersStore.selected_overview_market"
									:fixture="fixture"
								/>
								</div>
								<LiveFixtureDoubleMarket v-if="fixture.live && !fixture.outright"
									:primary_overview_market="dateTimeSportFiltersStore.selected_overview_market"
									:secondary_overview_market="dateTimeSportFiltersStore.selected_overview_market"
									:fixture="fixture"
									:padding="true"
								/>

								<PreFixtureDoubleMarket v-if="!fixture.live && !fixture.outright"
									:primary_overview_market="dateTimeSportFiltersStore.selected_overview_market"
									:secondary_overview_market="dateTimeSportFiltersStore.selected_overview_market"
									:fixture="fixture"
								/>
							</template>

					</template>
				</template>
			</div>
		</div>

	</div>

</div>
</template>

<style scoped>
.live-tab-info {
	scrollbar-width: none !important;
	overflow: visible !important;
	max-height: none !important;
}

.outrightinx {
	padding-left: 12px;
	padding-right: 12px;
	padding-top: 10px;
	padding-bottom: 10px;
	border-bottom: 1px dashed var(--tab-gray);
}
@media screen and (min-width: 320px) and (max-width: 767px) {
	.sports-main .sports-center-content .live-bet-dashboard {
		padding-left: 0;
		padding-right: 0;
	}

	.upcomimg_sport {
		padding-right: 12px;
		padding-left: 12px;
	}

	.competetion-date {
		background-color: var(--dark);
		padding: 8px 12px;
	}

	.live-bet-dashboard .live-tab-info .live-info-outer {
		padding: 0 0 2px;
		border-bottom: unset;
	}
}
</style>